import { render } from "./AttributesSection.vue?vue&type=template&id=07076d50"
import script from "./AttributesSection.vue?vue&type=script&lang=js"
export * from "./AttributesSection.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__